// @flow

import { get, keyBy, toString } from 'lodash';

import decodePlayer from '../normalizers/decodePlayer';

export default function getPlayersFromGames(games = []) {
  return games.reduce((outerMemo, game, index) => {
    const countryCode = get(game, 'competition.competition_type.country.iso_alpha_2_code');
    const hideProgress = !!get(game, 'competition.competition_type.sport.game_progress_irrelevant');
    const teams = keyBy(get(game, 'teams', []), 'id');
    return get(game, 'players', []).reduce(
      (obj, player) =>
        Object.assign(obj, {
          [player.id]: {
            awayAbbr: game.away_team_abbreviation || game.away_team_name,
            awayTeam: game.away_team_name,
            gameId: toString(game.id),
            homeAbbr: game.home_team_abbreviation || game.home_team_name,
            homeId: game.home_team_abbreviation,
            homeTeam: game.home_team_name,
            onesportCompetitionId: game.competition.onesport_id,
            onesportEntityId: player.onesport_id,
            onesportGameId: game.onesport_id,
            progress: !hideProgress ? game.progress : undefined,
            reverseOrder: countryCode === 'US',
            statusId: get(game, 'status.id'),
            ...decodePlayer(
              {
                team: get(teams, player.team_id),
                ...player
              },
              { ...game, gameOrder: index + 1 }
            )
          }
        }),
      outerMemo
    );
  }, {});
}
